import * as React from "react";
import {inject, observer} from "mobx-react";
import {ClipsFullscreenStore} from "../../../../lib/ClipsFullscreenStore";
import {Button} from "@ok/common/design-system/components/Button";
import {AuthorInfo, CLIP_URLS} from "../../../../lib/types";
import {AnonymControlWrapper} from "../../common/controls/AnonymControlWrapper";
import {l10n} from "@ok/web/modules/l10n/l10n";

const l10NPkg = l10n("clips");

interface ISubscribe {
    store?: ClipsFullscreenStore;
    authorInfo: AuthorInfo;
}

export const Subscribe: React.FC<ISubscribe> = inject("store")(observer(
    (props: ISubscribe): React.ReactElement => {
        const store = props.store!;

        const handleClick = () => {
            if (store.isAnonym) {
                return;
            }
            store.doRequest(CLIP_URLS.SUBSCRIBE);
            store.setSubscribed(true);
        };


        const component = !props.authorInfo.isSubscribed && props.authorInfo.isOkOwner ?
            (
                <AnonymControlWrapper>
                    <Button
                        data-tsid=""
                        size={"28"}
                        view={"primary-on-color"}
                        onClick={handleClick}
                    >
                        <Button.Label>
                            {l10NPkg.getLMsg("subscribe")}
                        </Button.Label>
                    </Button>
                </AnonymControlWrapper>
            ) : <div></div>;

        return component;
    }
));
